module.exports = __webpack_public_path__ + "static/6-c5df77eb6272acd552decfe348295a47.png";